var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.$route.path === '/service/production')?_c('page',[_c('ZuiHeader'),_vm._v(" "),_c('SubPageTemplate',{attrs:{"page-title":"主题产品","dynamically-tab":"","pid":_vm.$cid.intro.zhuTiChanPin,"page-size":6,"type":"article","ext1-empty":false,"tuijian":true,"video-mask":false},on:{"article-click":_vm.articleClick}}),_vm._v(" "),_c('ZuiFooter')],1):_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19d20754","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/service/production.vue
// module id = 1396
// module chunks = 0